import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ContentTemplate from './content-template.js';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import Model from "@ckeditor/ckeditor5-ui/src/model";
import { createDropdown, addListToDropdown } from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import contentTemplatesIcon from './theme/icons/content-templates.svg';

export default class ContentTemplates extends Plugin {

	init() {
		const editor = this.editor;
        this._templates = [];

        window.editorSettings.contentTemplates.forEach((template, index) => {
            this._templates[index] = new ContentTemplate(this.editor, 'ContentTemplate' + index, template.html);
        });

		editor.ui.componentFactory.add('contentTemplates', locale => {
			const dropdownView = createDropdown(locale);

			dropdownView.buttonView.set({
				label: editor.t('Insert template'),
				tooltip: true,
				icon: contentTemplatesIcon,
			});

			const items = new Collection();

			window.editorSettings.contentTemplates.forEach((template, index) => {
				items.add({
					type: 'button',
					model: new Model({
						id: index,
						withText: true,
						label: template.translations[locale.contentLanguage] ? template.translations[locale.contentLanguage] : template.translations['en'],
					})
				});
			});

			addListToDropdown(dropdownView, items);

			dropdownView.on('execute', (eventInfo) => {
				let { id } = eventInfo.source;

				editor.model.change(writer => {
                    let element = this._templates[id].write(writer);
                    editor.model.insertContent(element);
				} );
			} );

			return dropdownView;
		});
	}
}
